import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import AccountPaths from 'Application/Account/Constants/AccountPaths'
import Icon from 'Components/Icon'
import { useGetInsuranceExpertFieldsCurrentUserQuery, useGetUserProfileQuery } from 'Services/api'

interface IProps {
  messageType: number
}

const AccessDenied: React.FC<IProps> = (props) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  const { data: userProfileInfo } = useGetUserProfileQuery()

  const {
    data: insuranceExpertFields,
    isError,
    refetch: refetchExpertFields,
  } = useGetInsuranceExpertFieldsCurrentUserQuery()

  return (
    <>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-center gap-2">
          <div className="text-lg font-bold pl-2">خطای دسترسی</div>
        </div>
      </div>

      <div className="flex flex-col grow overflow-auto">
        <div className="px-6 pb-6">
          {props.messageType === 2 ? (
            userProfileInfo?.errorMessages?.map((text) => {
              return (
                <div className="flex gap-2 px-6 py-3">
                  <div
                    id="alert-error"
                    className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800"
                    role="alert"
                  >
                    <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
                      <Icon name="ic_error" className="w-6 h-6" />
                    </div>
                    <span className="sr-only">error</span>
                    <div className="ms-3 text-sm font-semibold grow">{t(text)}</div>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="flex gap-2 px-6 py-3">
              <div
                id="alert-error"
                className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800"
                role="alert"
              >
                <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
                  <Icon name="ic_error" className="w-6 h-6" />
                </div>
                <span className="sr-only">error</span>
                <div className="ms-3 text-sm font-semibold grow">
                  {props.messageType === 1
                    ? t('SIGNATURE_REQUIRED_MESSAGE')
                    : t('ACCESS_DENIED_MESSAGE')}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="cta">
        {(!insuranceExpertFields || isError) && (
          <button
            className="btn btn-info btn-lg flex gap-2 items-center justify-center w-full"
            onClick={() => refetchExpertFields()}
          >
            <Icon name="rotate-left" className="w-6 h-6" />
            {t('GET_USER_DATA')}
          </button>
        )}
        <button
          className="btn btn-error btn-lg flex gap-2 items-center justify-center w-full"
          onClick={() =>
            navigate(props.messageType === 1 ? AccountPaths.AccountMain : VisitsPaths.VisitsMain)
          }
        >
          <Icon name="arrow-right" className="w-6 h-6" />
          {t(props.messageType === 1 ? 'GO_TO_ACOOUNT_PAGE' : 'RETURN')}
        </button>
      </div>
    </>
  )
}

export default AccessDenied
